import React, { useState, useEffect } from "react";
import QuoteForm from "../../components/press/QuoteForm";
import { ChevronLeft, Loader2 } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { PressService } from "../../services/admin/PressService";
import { useNotification } from "../../context/NotificationContext";

export default function EditQuotePage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { showNotification } = useNotification();
    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchQuote = async () => {
            try {
                const data = await PressService.getQuoteById(id);
                setQuote(data);
            } catch (error) {
                showNotification({ message: "Failed to fetch quote", type: "error" });
                navigate("/admin/press");
            } finally {
                setLoading(false);
            }
        };
        fetchQuote();
    }, [id, navigate, showNotification]);

    const handleUpdate = async (data) => {
        try {
            const response = await PressService.updateQuote(id, data);
            if (response.status === "success") {
                showNotification({ message: "Quote updated successfully", type: "success" });
                navigate("/admin/press");
            } else {
                showNotification({ message: response.message || "Failed to update quote", type: "error" });
            }
        } catch (error) {
            showNotification({ message: "An error occurred during update", type: "error" });
        }
    };

    return (
        <div className="p-6 lg:p-10 max-w-5xl mx-auto">
            <div className="flex items-center gap-4 mb-8">
                <button
                    onClick={() => navigate("/admin/press")}
                    className="p-2 hover:bg-black/5 dark:hover:bg-white/5 rounded-full transition-colors"
                >
                    <ChevronLeft size={24} />
                </button>
                <div>
                    <h1 className="text-3xl font-normal text-black dark:text-white" style={{ fontFamily: "Playfair Display, serif" }}>Edit Press Quote</h1>
                    <p className="text-black dark:text-white/50 text-sm">Update the featured quote for your press page.</p>
                </div>
            </div>

            {loading ? (
                <div className="flex flex-col items-center justify-center py-20">
                    <Loader2 size={40} className="animate-spin text-jazz-brown mb-4" />
                    <p className="text-black dark:text-white/50 font-medium italic">Loading quote details...</p>
                </div>
            ) : (
                <QuoteForm initialData={quote} onSubmit={handleUpdate} isEditing={true} />
            )}
        </div>
    );
}
